import store from '@/store/store'
import moment from 'moment'

class TestReportModule {

  setReportStatuses(status) {
    store.commit('TEST_REPORT_STATUS_SET', status)
  }

  getReportStatuses = () => store.state.testReport.statuses

  setReportLastRunDate(datetime) {
    store.commit('TEST_REPORT_LAST_RUN_DATE_SET', moment(datetime).format('yyyy/MM/DD HH:mm'))
  }

  getReportLastRunDate = () => store.state.testReport.lastRunDate

  // intents
  setIntents(failedIntents) {
    store.commit('FAILED_INTENTS_SET', failedIntents)
  }

  getIntents = () => store.state.testReport.intents

  setSelectedIntent(selectedIntent) {
    store.commit('SELECTED_FAILED_INTENT_SET', selectedIntent)
  }

  getSelectedIntent = () => store.state.testReport.selectedIntent

  // examples
  setFailedExample(selectedExample) {
    store.commit('SELECTED_FAILED_EXAMPLE_SET', selectedExample)
  }

  getSelectedExample = () => store.state.testReport.selectedExample
}

export default new TestReportModule()
